<form [formGroup]="form">
  <div class="row">
    <div class="col-md-6 form-group">
      <label>{{ 'organizations.name' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['name']"
      ></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'organizations.address' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['address']"
      ></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'organizations.description' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['description']"
      ></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'organizations.status' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['status']"
        [inputType]="'select'"
        [selectValues]="status"
      ></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'organizations.type' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['type']"
        [inputType]="'select'"
        [selectValues]="types"
        [selectNames]="typeNames"
      ></app-input-with-error>
    </div>

    @if (this.form.controls['type'].value === OrganizationType.CUSTOMER) {
      <div class="col-md-6 form-group">
        <label>{{ 'organizations.parentOrganization' | translate }}</label>
        <p-select
          [options]="partnerOrganizations"
          formControlName="parentOrganizationId"
          optionValue="id"
          optionLabel="name"
          [filter]="true"
          filterBy="name"
          [filterPlaceholder]="'search' | translate"
          [showClear]="true"
          [loading]="organizationsLoading"
          class="w-100"
        />
      </div>
    }

    <div class="col-md-6 form-group">
      <label>{{ 'organizations.motherOrganization' | translate }}</label>
      <p-select
        [options]="motherOrganizations"
        formControlName="motherOrganizationId"
        optionValue="id"
        optionLabel="name"
        [filter]="true"
        filterBy="name"
        [filterPlaceholder]="'search' | translate"
        [showClear]="true"
        [loading]="organizationsLoading"
        class="w-100"
      />
    </div>
  </div>
  <app-error [error]="error"></app-error>
</form>
